import React, { useState } from 'react';
import { Menu, X, Shield } from 'lucide-react';
export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  return <header className="bg-gray-900 border-b border-gray-800" data-id="element-93">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-94">
        <div className="flex justify-between h-16" data-id="element-95">
          <div className="flex items-center" data-id="element-96">
            <Shield className="h-8 w-8 text-red-500" data-id="element-97" />
            <span className="ml-2 text-xl font-bold text-white" data-id="element-98">Pentforce</span>
          </div>
          <div className="hidden md:flex items-center space-x-8" data-id="element-99">
            <a href="#services" className="text-gray-300 hover:text-red-500 transition-colors" data-id="element-100">
              Services
            </a>
            <a href="#about" className="text-gray-300 hover:text-red-500 transition-colors" data-id="element-101">
              About Us
            </a>
            <a href="#process" className="text-gray-300 hover:text-red-500 transition-colors" data-id="element-102">
              Process
            </a>
            <a href="#contact" className="text-gray-300 hover:text-red-500 transition-colors" data-id="element-103">
              Contact
            </a>
            <button className="bg-red-600 hover:bg-red-700 text-white py-2 px-4 rounded transition-colors" data-id="element-104">
              Get Started
            </button>
          </div>
          <div className="md:hidden flex items-center" data-id="element-105">
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="text-gray-400 hover:text-white" data-id="element-106">
              {mobileMenuOpen ? <X className="h-6 w-6" data-id="element-107" /> : <Menu className="h-6 w-6" data-id="element-108" />}
            </button>
          </div>
        </div>
      </div>
      {mobileMenuOpen && <div className="md:hidden" data-id="element-109">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-gray-800" data-id="element-110">
            <a href="#services" className="block px-3 py-2 text-gray-300 hover:text-red-500" data-id="element-111">
              Services
            </a>
            <a href="#about" className="block px-3 py-2 text-gray-300 hover:text-red-500" data-id="element-112">
              About Us
            </a>
            <a href="#process" className="block px-3 py-2 text-gray-300 hover:text-red-500" data-id="element-113">
              Process
            </a>
            <a href="#contact" className="block px-3 py-2 text-gray-300 hover:text-red-500" data-id="element-114">
              Contact
            </a>
            <button className="w-full mt-2 bg-red-600 hover:bg-red-700 text-white py-2 px-4 rounded transition-colors" data-id="element-115">
              Get Started
            </button>
          </div>
        </div>}
    </header>;
}